/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendInvitationAcceptDto } from '../../models/backend-invitation-accept-dto';
import { BackendInvitationAcceptRequestDto } from '../../models/backend-invitation-accept-request-dto';

export interface AccessInvitationsAcceptCreate$FormData$Params {
  body: BackendInvitationAcceptRequestDto;
}

export function accessInvitationsAcceptCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: AccessInvitationsAcceptCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendInvitationAcceptDto>> {
  const rb = new RequestBuilder(rootUrl, accessInvitationsAcceptCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendInvitationAcceptDto>;
    }),
  );
}

accessInvitationsAcceptCreate$FormData.PATH = '/api/access/invitations/accept/';
